import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";

import "./loginPage.css";

export default function Login(props) {
  let history = useHistory();
  const [loginStep, setLoginStep] = useState(0);
  const [loginError, setLoginError] = useState("");
  const date = new Date();
  const time = date.getHours();
  const [greetingMessage, setGreetingMessage] = useState("");
  const { register, handleSubmit, setValue } = useForm();
  const sp = `${process.env.REACT_APP_LOCAL_SERVER}/php/onlinebooking`;

  useEffect(() => {
    // const getScreenOrientation = () => 
    // {
    //   if (window.innerHeight > window.innerWidth)
    //     return "portrait";
    //   else
    //     return "landscape";
    // }

    // console.log(getScreenOrientation())

    localStorage.clear();

    if (time >= 0 && time < 12) {
      setGreetingMessage("Good Morning");
    } else if (time >= 12 && time < 18) {
      setGreetingMessage("Good Afternoon");
    } else {
      setGreetingMessage("Good Evening");
    }
  }, [time]);

  const onSubmitEmail = async (data) => {
    //console.log(data);
    const requestOptions = {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ action: "email", email: data.email }),
    };
    fetch(sp + "/login.php", requestOptions)
      .then(async (response) => {
        const loginResult = await response.json();
        //console.log(loginResult);
        if (loginResult.result === "Success") {
          setLoginError("");
          setLoginStep(1);
          setValue("patient_id", loginResult.detail.patient_id);
        } else if (loginResult.result === "NoPatient") {
          setLoginError(loginResult.detail);
        }
      })
      .catch((error) => {
        //setPageError(true);
        //console.error('There was an error!', error);
      });
  };

  const onSubmitCode = async (data) => {
    //console.log(data);

    const requestOptions = {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ action: "code", patient_id: data.patient_id, code: data.code }),
    };
    fetch(sp + "/login.php", requestOptions)
      .then(async (response) => {
        const loginResult = await response.json();
        
        if (loginResult.result === "Success") {
          localStorage.setItem("login_code", data.code);
          localStorage.setItem("patient_id", loginResult.detail.patient_id);
          localStorage.setItem("patient_name", loginResult.detail.patient_name);
          localStorage.setItem("practice_id", loginResult.practice.practice_id);
          localStorage.setItem("practice_name", loginResult.practice.practice_name);
          localStorage.setItem("practice_phone", loginResult.practice.practice_publicphone);
          localStorage.setItem("practice_email", loginResult.practice.practice_email);
          history.push(`/home`);
        } else {
          localStorage.clear();
          setLoginError(loginResult.detail);
          setLoginStep(1);
        }
      })
      .catch((error) => {
        //setPageError(true);
        //console.error('There was an error!', error);
      });
  };

  function newPatient() {
    localStorage.setItem("login_code", "_new");
    history.push('/register');
  }

  return (
    <>
      {window.innerWidth >= 670 ? (
        <div className="unsplash-image">
          {loginStep === 0 && (
            <div className="signup">
              <div className="signup-leftside">
                <h2>{greetingMessage}</h2>
                <hr></hr>
                <h4 style={{color: "white"}}>Welcome to ..... Patient Portal</h4>
                <h4 style={{color: "white", marginTop: "50px"}}>New to the patient portal?</h4>
                <button className="login-signup-btn" type="button" onClick={newPatient}>
                  Sign up!
                </button>
              </div>
              <div className="signin-rightside">
                <form onSubmit={handleSubmit(onSubmitEmail)}>
                  <h2>Sign In</h2>
                  <hr></hr>
                  <p className="sign-in-help-text">Sign in using the email address you gave to the practice</p>
                  <input className="login-email" type="email" placeholder="Email Address" {...register("email", { required: true })} /> 
                  <div>{loginError}</div> 
                  <button className="login-signin-btn" type="submit">
                    Sign in
                  </button>
                </form>
                <a href="https://www.dentalplus.co.uk" target="_blank" rel="noopener noreferrer">
                  Powered by DentalPlus
                </a>
              </div>
            </div>
          )}
          {loginStep === 1 && (
            <div className="signup">
              <div className="signup-leftside">
                <h2>{greetingMessage}</h2>
                <hr></hr>
                <h4 style={{color: "white"}}>Welcome to ..... Patient Portal</h4>
                <h4 style={{color: "white", marginTop: "50px"}}>New to the patient portal?</h4>
                <button className="login-signup-btn" type="button" onClick={newPatient}>
                  Sign up!
                </button>
              </div>
              <div className="signin-rightside">
                <form onSubmit={handleSubmit(onSubmitCode)}>
                  <h2>Enter Code</h2>
                  <hr></hr>
                  <p className="sign-in-help-text">Please enter the code we have emailed you. You may need to check your spam folder.</p>
                  <input className="login-email" placeholder="Emailed Code" {...register("code", { required: true })} />
                  <div>{loginError}</div>
                  <button className="login-signin-btn" type="submit">
                    Confirm
                  </button>
                </form>
                <a href="https://www.dentalplus.co.uk" target="_blank" rel="noopener noreferrer">
                  Powered by DentalPlus
                </a>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>
          {loginStep === 0 && (
            <div className="mobile-login-form">
              <div className="mobile-login-background"></div>

              <form className="mobile-login-content" onSubmit={handleSubmit(onSubmitEmail)}>
                <div className="mobile-login-header">
                  <h1 style={{ color: "white", borderBottom: "2px solid #fff" }}>Sign In</h1>
                </div>

                <div className="mobile-login-inputs">
                  <p className="mobile-login-help-text">
                    Welcome to ..... Patient Portal<br />
                    <br />
                    Sign in using the email address you gave to the practice
                  </p>
                  <input className="mobile-login-email" type="email" autoCapitalize="off" placeholder="Email Address" {...register("email", { required: true })} />
                  <p className="mobile-login-help-text">{loginError}</p>
                </div>
                <button className="mobile-login-signin-button" type="submit">
                  Sign in
                </button>
              </form>

              <footer className="mobile-login-footer">
                <p className="mobile-login-help-text" style={{ color: "black" }}>
                  New to the patient portal?
                </p>
                <button className="mobile-login-signup-button" type="button" onClick={newPatient}>
                  Sign up!
                </button>
                </footer>
                <div className="mobile-login-dentalplus">
                <a className="dentalplus-website" href="https://www.dentalplus.co.uk" target="_blank" rel="noopener noreferrer">
                  Powered by DentalPlus
                </a>
                </div>
            </div>
          )}
          {loginStep === 1 && (
            <div className="mobile-login-form">
              <div className="mobile-login-background"></div>

              <form className="mobile-login-content" onSubmit={handleSubmit(onSubmitCode)}>
                <div className="mobile-login-header">
                  <h1 style={{ color: "white", borderBottom: "2px solid #fff" }}>Enter Code</h1>
                </div>

                <div className="mobile-login-inputs">
                  <p className="mobile-login-help-text">
                    Please enter the code we have emailed you. <br />
                    <br />
                    You may need to check your spam folder.
                  </p>
                  <input className="mobile-login-email" placeholder="Emailed Code" autoCapitalize="off" {...register("code", { required: true })} />
                  <p className="mobile-login-help-text">{loginError}</p>
                </div>
                <button className="mobile-login-signin-button" type="submit">
                  Confirm
                </button>
              </form>

              <footer className="mobile-login-footer">
                <p className="mobile-login-help-text" style={{ color: "black" }}>
                  New to the patient portal?
                </p>
                <button className="mobile-login-signup-button" type="button" onClick={newPatient}>
                  Sign up!
                </button>
                <div className="mobile-login-footer-spacer"></div>
                <a className="dentalplus-website" href="https://www.dentalplus.co.uk" target="_blank" rel="noopener noreferrer">
                  Powered by DentalPlus
                </a>
              </footer>
            </div>
          )}
        </div>
      )}
    </>
  );
}
